import { HandoverApiRepository } from "@/app/infrastructures/repositories/api/HandoverApiRepository";
import {
  HandoverList,
  HandoverDetail,
  PartnerVendorList,
  FailedVendorStt,
  HandoverFailedStt,
  RetryHandoverVendorResult,
} from "@/domain/entities/Handover";
import { UpdateHandoverRequestInterface } from "@/data/payload/contracts/HandoverRequest";
import {
  ResponsePayload,
  ResponseSttDetail
} from "@/domain/entities/ResponsePayload";
import { SubconsoleEntities } from "@/domain/entities/Subconsole";
import { injectable } from "tsyringe";
import {
  RequestExportFileExcel,
  RequestFailedVendorStt,
  RequestListHandover,
  RequestPartnerVendorList,
  RetryHandoverVendorRequest
} from "@/data/payload/api/HandoverApiRequest";

@injectable()
export class HandoverPresenter {
  private repository: HandoverApiRepository;

  constructor(repository: HandoverApiRepository) {
    this.repository = repository;
  }

  public getListSubconsole(parentId: number): Promise<SubconsoleEntities> {
    return this.repository.getListSubconsole(parentId);
  }

  public getHandoverList(params: RequestListHandover): Promise<HandoverList> {
    return this.repository.getHandoverList(params);
  }

  public getDetailHandover(handoverId: number): Promise<HandoverDetail> {
    return this.repository.getDetailHandover(handoverId);
  }

  public getSttDetail(
    stt: string,
    bagNo: string,
    partnerCode: string
  ): Promise<ResponseSttDetail> {
    return this.repository.getSttDetail(stt, bagNo, partnerCode);
  }

  public updateHandover(
    payload: UpdateHandoverRequestInterface
  ): Promise<ResponsePayload> {
    return this.repository.updateHandover(payload);
  }

  public getPartnerVendorList(
    params: RequestPartnerVendorList
  ): Promise<PartnerVendorList[]> {
    return this.repository.getPartnerVendorList(params);
  }

  public getExcelFile(params: RequestExportFileExcel): Promise<any> {
    return this.repository.getExcelFile(params);
  }

  public getHandoverReceipt(id: number) {
    return this.repository.getHandoverReceipt(id);
  }

  public getFailedVendorStt(
    handoverId: number,
    params?: RequestFailedVendorStt
  ): Promise<FailedVendorStt> {
    return this.repository.getFailedVendorStt(handoverId, params);
  }

  public retryHandoverVendorOrder(
    handoverId: number,
    payload?:
      | RetryHandoverVendorRequest
      | { sttNo?: string; sttNos?: string[] }
      | string
      | string[]
  ): Promise<RetryHandoverVendorResult> {
    return this.repository.retryHandoverVendorOrder(handoverId, payload);
  }

  public getHandoverFailedStt(handoverId: number): Promise<HandoverFailedStt> {
    return this.repository.getHandoverFailedStt(handoverId);
  }
  
}
